import { combineEpics, ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { TypeActionApp } from "../app/actionApp";
import { actionPlayerBaseSelectBase } from "./actionPlayerBase";
import { epicBuildings } from "./buildings/epicBuildings";
export var epicBase = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), mapTo(actionPlayerBaseSelectBase(1)));
};
export var epicPlayerBase = combineEpics(epicBase, epicBuildings);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/epicPlayerBase.ts
// module id = 2040
// module chunks = 3